<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Addition Of Manpower
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Work Order Date</label>
                <div class="input-group" style="height: auto;">
                    <input class="form-control" name="WorkOrderDate" placeholder="Ex. DD/MMM/YYYY"
                        [(ngModel)]="WorkOrderDate" #HolidayDate="ngModel" ngbDatepicker #d1="ngbDatepicker"
                        [minDate]="{ year:1930, month: 12, day: 31 }" [maxDate]="{ year: 2124, month: 12, day: 31 }"
                        style="height: auto; font-size: small; padding: 0.2rem 0.4rem;"
                        [ngModelOptions]="{standalone: true}" [disabled]="objdata.AllocationType === 'O'" />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()" type="button"
                        style="height: auto; padding: 0.25rem 0.4rem; font-size: small;"
                        [disabled]="objdata.AllocationType === 'O'"></button>
                </div>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Work Order No.</label>
                <input name="workorderno" [(ngModel)]="WorkOrderNumber" type="text" class="form-control"
                    [disabled]="objdata.AllocationType === 'O'" />
            </div>
            <div class="col-md-2 px-1" *ngIf="objdata.editMode">
                <label class="Label">Entry No.</label>
                <input name="entryNo" type="text" [(ngModel)]="EntryNo" class="form-control" disabled />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-5 px-1">
                <label class="Label">Branch<span class="text-danger">*</span></label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')"
                    [disabled]="objdata.editMode || objdata.siteMode">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Client <span class="text-danger">*</span></label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')"
                    [disabled]="objdata.editMode || objdata.siteMode">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site <span class="text-danger">*</span></label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site');"
                    [disabled]="objdata.editMode || objdata.siteMode">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label2">Current Manpower Balance</label>
                <input name="total manpower" [(ngModel)]="Total" type="text" class="form-control" disabled />
            </div>
            <div class="col-md-2 px-1"><br>
                <button class="btn btn-sm btn-primary" name="history" (click)="OpenDesignationSummary()">
                    <i class="bi bi-hourglass-split" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'History':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Attachment</label>
                <div class="file-input-container">
                    <input class="form-control form-control-sm" id="formFileSm" type="file" *ngIf="!displayedFileName"
                        (change)="onFileSelected($event)"
                        [disabled]="SiteId === 0 || SiteId === null || objdata.AllocationType === 'O'" accept=".pdf" />
                    <span *ngIf="displayedFileName" class="file-name">{{ displayedFileName }}</span>
                    <span *ngIf="displayedFileName "> <button class="btn btn-sm" name="view" style="color: blue;"
                            (click)="viewFile()"><i class="bi bi-eye"></i></button></span>
                    <button class="btn btn-sm" *ngIf="displayedFileName" (click)="removeFile()"
                        [disabled]="objdata.AllocationType === 'O'">
                        <i class="bi bi-trash"></i>
                    </button>
                </div>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label">Allocation Type</label>
                <input name="addition" [(ngModel)]="AllocationType" type="text" class="form-control" disabled />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Designation <span class="text-danger">*</span></label>
                <ng-select name="designation" [items]="DesignationLoad" bindLabel="DesignationName"
                    [(ngModel)]="DesignationId" (change)="onSelectChange('Designation');"
                    bindValue="DesignationMasterID" [disabled]="SiteId === 0 || SiteId === null">
                    <ng-option *ngFor="let segment of DesignationLoad" [value]="segment.DesignationMasterID">
                        {{ segment.DesignationName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Duty <span class="text-danger">*</span></label>
                <ng-select name="dutyname" [items]="DutyLoad" [(ngModel)]="DutyId" (change)="onSelectChange('Duty')"
                    bindLabel="DutyName" bindValue="DutyMasterID" [disabled]="SiteId === 0 || SiteId === null">
                    <ng-option *ngFor="let segment of DutyLoad" [value]="segment.DutyMasterID">
                        {{ segment.DutyName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label">Shift <span class="text-danger">*</span></label>
                <ng-select name="Shift" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                    [(ngModel)]="ShiftID" (change)="onSelectChange('Shift')"
                    [disabled]="SiteId === 0 || SiteId === null">
                    <ng-option *ngFor="let segment of Shift" [value]="segment.ShiftMasterID">
                        {{ segment.ShiftTitle }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">No Of Manpower <span class="text-danger">*</span></label>
                <input name="manpower" style="text-align: right;" [(ngModel)]="NoOfEmp" type="number"
                    class="form-control" [disabled]="SiteId === 0 || SiteId === null" pattern="[0-9]{1,7}"
                    (keypress)="onKeyPress($event)" min="0" />
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">From Date <span class="text-danger">*</span></label>
                <div class="input-group" style="height: auto;">
                    <input class="form-control" name="DateFrom" placeholder="Ex. DD/MMM/YYYY" [(ngModel)]="FromDate"
                        #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                        [disabled]="SiteId === 0 || SiteId === null" [minDate]="{ year:1930, month: 12, day: 31 }"
                        [maxDate]="{ year: 2124, month: 12, day: 31 }"
                        style="height: auto; font-size: small; padding: 0.2rem 0.4rem;"
                        [ngModelOptions]="{standalone: true}" readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"
                        style="height: auto; padding: 0.25rem 0.4rem; font-size: small;"></button>
                </div>
            </div>
            <div class="col-md-2 px-1">
                <!-- [disabled]="SiteId === 0 || SiteId === null  || (objdata.editMode && !ToDate && editMode && RefID !== 0)" -->
                <label class="Label">To Date</label>
                <div class="input-group" style="height: auto;">
                    <input class="form-control" name="DateTo" placeholder="Ex. DD/MMM/YYYY" [(ngModel)]="ToDate"
                        ngbDatepicker #d3="ngbDatepicker" [minDate]="{ year:1930, month: 12, day: 31 }"
                        [maxDate]="{ year: 2124, month: 12, day: 31 }" [disabled]="CheckIsDisabled()"
                        style="height: auto; font-size: small; padding: 0.2rem 0.4rem;"
                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onToDateChange()" />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()" type="button"
                        style="height: auto; padding: 0.25rem 0.4rem; font-size: small;"></button>
                </div>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Effective Date</label>
                <div class="input-group" style="height: auto;">
                    <input class="form-control" name="DateFrom" placeholder="Ex. DD/MMM/YYYY"
                        [(ngModel)]="EffectiveDate" #HolidayDate="ngModel" ngbDatepicker #d5="ngbDatepicker"
                        [minDate]="{ year:1930, month: 12, day: 31 }" [maxDate]="{ year: 2124, month: 12, day: 31 }"
                        style="height: auto; font-size: small; padding: 0.2rem 0.4rem;"
                        [ngModelOptions]="{standalone: true}" readonly disabled />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d5.toggle()" type="button"
                        style="height: auto; padding: 0.25rem 0.4rem; font-size: small;" disabled></button>
                </div>
            </div>
            <div class="col-md-4 px-1">
                <label class="Label">Remark</label>
                <textarea name="workorderno" [(ngModel)]="Remark" class="form-control" rows="1" cols="50"
                    style="resize: none;"></textarea>
            </div>
            <div class="col-md-2 px-1"><br>
                <button class="btn btn-sm btn-primary" name="add" (click)="add()"
                    [disabled]="objdata.AllocationType === 'O'">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    <!-- {{!isDisabled?'Add':'Loading...'}} -->
                    {{ isDisabled ? 'Loading...' : (editMode ? 'Update' : 'Add') }}
                </button>
            </div>
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" style="display: none;">ESS_ShiftWiseManpowerDetails Id</th>
                            <th scope="col" *ngIf="objdata.editMode" style="display: none;">Entry No</th>
                            <th scope="col" style="display: none;">Is MonthLocked</th>
                            <th scope="col" style="display: none;">Branch ID</th>
                            <th scope="col" style="display: none;">Branch </th>
                            <th scope="col" style="display: none;">Client ID</th>
                            <th scope="col" style="display: none;">Client </th>
                            <th scope="col" style="display: none;">Site ID</th>
                            <th scope="col" style="display: none;">Site </th>
                            <th scope="col" style="display: none;">Designation ID</th>
                            <th scope="col">Designation </th>
                            <th scope="col" style="display: none;">Duty ID</th>
                            <th scope="col">Duty </th>
                            <th scope="col" style=" display: none;">Shift ID</th>
                            <th scope="col">Shift</th>
                            <th scope="col">From Date</th>
                            <th scope="col">To Date</th>
                            <th scope="col">Effective Date</th>
                            <th scope="col">No of Employees</th>
                            <th scope="col">Remarks</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let shift of AddManpowerTable; let i = index">
                            <th scope="row" [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ i + 1 }}</th>
                            <td style="display: none;">{{shift.ESS_ShiftWiseManpowerDetailsId}}</td>
                            <td *ngIf="objdata.editMode" style="display: none;"> {{shift.EntryNo}}</td>
                            <td style="display: none;"> {{shift.IsMonthLocked}}</td>
                            <td style="display: none;">{{ shift.BranchId }}</td>
                            <td style="display: none;">{{ shift.BranchName }}</td>
                            <td style="display: none;">{{ shift.ClientId }}</td>
                            <td style="display: none;">{{ shift.ClientGroupName }}</td>
                            <td style="display: none;">{{ shift.SiteId }}</td>
                            <td style="display: none;">{{ shift.Site }}</td>
                            <td style="display: none;">{{ shift.DesignationId }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.DesignationName }}
                            </td>
                            <td style="display: none;">{{ shift.DutyId }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.DutyName }}</td>
                            <td style="display: none;">{{ shift.ShiftId }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.ShiftTitle }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.FromDate }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.ToDate }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{
                                shift.ReductionEffectiveAfter }}</td>
                            <td class="right-align" [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">
                                <span class="no-of-person">{{ shift.NoOfPerson }}
                                </span>
                            </td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">{{ shift.Remarks }}</td>
                            <td [ngClass]="{'highlight-row': shift.IsMonthLocked === 1}">
                                <button class="btn btn-sm btn-group-toggle" style="height: 50%; border: none;"
                                    [disabled]="shift.IsMonthLocked === 1 || objdata.AllocationType === 'O'"
                                    (click)="onEditClick(shift, i)">
                                    <i class="bi bi-pencil-square text-warning"
                                        [ngClass]="{'icon-grey': shift.IsMonthLocked === 1}"></i>
                                </button>

                                &nbsp; <button class="btn btn-sm" name="delete" style="color: red;"
                                    (click)="deleteRow(i)"
                                    [disabled]="shift.IsMonthLocked === 1 || objdata.AllocationType === 'O' || editMode"><i
                                        class="bi bi-trash-fill"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-7 px-1">
            </div>
            <div class="col-md-3 px-1">
                <label class="Label1">Total Alloted Manpower :-</label>
            </div>
            <div class="col px-1">
                <input name="totalallotedmanpoer" style="text-align: right;" type="number" class="form-control"
                    [(ngModel)]="TotalAllotedManpower" disabled />
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsEdit || this.common.PageRight.IsAdd "
                    class="btn btn-sm btn-primary" name="save" (click)="save()"
                    [disabled]="objdata.AllocationType === 'O' || editMode">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
                &nbsp;<button class="btn btn-sm btn-primary" name="refresh" (click)="refresh()">
                    <i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Back':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>